import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { Booking } from '../../../entities/booking';
import * as moment from 'moment-timezone';
import { Api } from '../../../providers/api';

@Component({
    selector: 'page-my-bookings',
    templateUrl: 'my-bookings.html',
})
export class MyBookingsPage {

    showingCurrent: boolean = true;
    currentBookings: Booking[] = [];
    previousBookings: Booking[] = [];

    constructor(
        private api: Api,
        private navParams: NavParams
    ) {
    }

    ngAfterViewInit() {
        let bookings: Booking[] = this.navParams.get('bookings');
        this.processBookings(bookings);
    }

    showCurrent(show: boolean) {
        this.showingCurrent = show;
    }

    async refreshPage(refresher) {
        let bookings: Booking[] = await this.api.getMyBookings();
        this.previousBookings = [];
        this.currentBookings = [];
        this.processBookings(bookings);
        refresher.complete();
    }

    processBookings(bookings: Booking[]) {
        for (let i in bookings) {

            let booking: Booking = Booking.createFromObject(bookings[i]);
            if (booking === undefined) continue;

            let lastMonth = moment().subtract({months: 1});
            let lastMonthUnix = parseInt(lastMonth.format('x'));
            let departureUnix = parseInt(booking.departing_at.format('x'));

            if (departureUnix < lastMonthUnix) continue;

            switch (booking.status) {
                case 'Shipped':
                case 'Cancelled':
                    this.previousBookings.push(booking);
                    continue;
            }
            this.currentBookings.push(booking);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/bookings/my-bookings/my-bookings.ts